import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  className?: string;
}

const KlubCoffeeIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#511010",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63.8132 40.5295C70.8451 40.5295 76.5455 46.2299 76.5455 53.2618C76.5455 60.2936 70.8451 65.994 63.8132 65.994"
        fill={color}
      />
      <path
        d="M56.9284 32.4257H24.8849C21.0825 32.4257 18 35.508 18 39.3106V64.4691C18 72.0738 24.165 78.2388 31.7697 78.2388H50.0436C57.1312 78.2388 62.9002 72.8638 63.6612 65.9785C56.7011 65.8949 51.0808 60.2413 51.0808 53.2614C51.0808 46.2299 56.7813 40.5295 63.8132 40.5295L63.8133 39.3106C63.8133 35.508 60.7308 32.4257 56.9284 32.4257Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 86C16 84.8954 16.8954 84 18 84H63.8133C64.9179 84 65.8133 84.8954 65.8133 86C65.8133 87.1045 64.9179 88 63.8133 88H18C16.8954 88 16 87.1045 16 86Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7203 8.42543C29.5899 9.10644 29.7429 10.3635 29.0619 11.2332L28.4441 12.022C27.5764 13.1301 27.5764 14.6872 28.4441 15.7954L29.6795 17.373C29.6795 17.373 29.6795 17.373 29.6795 17.373C31.6815 19.9296 31.6815 23.5221 29.6795 26.0787L29.0618 26.8675C28.3808 27.7372 27.1238 27.8901 26.2541 27.2091C25.3844 26.5281 25.2315 25.271 25.9125 24.4014L26.5302 23.6125C27.398 22.5044 27.398 20.9473 26.5302 19.8392L25.2948 18.2615C25.2948 18.2615 25.2948 18.2615 25.2948 18.2615C23.2928 15.7049 23.2928 12.1124 25.2948 9.55586C25.2948 9.55586 25.2948 9.55586 25.2948 9.55586L25.9125 8.76702C26.5935 7.89736 27.8506 7.74443 28.7203 8.42543Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.1397 8.42543C43.0094 9.10644 43.1623 10.3635 42.4813 11.2332L41.8636 12.022C40.9959 13.1301 40.9959 14.6872 41.8636 15.7954L43.099 17.373C43.099 17.373 43.099 17.373 43.099 17.373C45.101 19.9296 45.101 23.5221 43.099 26.0787L42.4813 26.8675C41.8003 27.7372 40.5432 27.8901 39.6736 27.2091C38.8039 26.5281 38.651 25.271 39.332 24.4014L39.9497 23.6125C40.8175 22.5044 40.8175 20.9473 39.9497 19.8392L38.7143 18.2615C38.7143 18.2615 38.7143 18.2615 38.7143 18.2615C36.7123 15.7049 36.7123 12.1124 38.7143 9.55586C38.7143 9.55586 38.7143 9.55586 38.7143 9.55586L39.332 8.76702C40.013 7.89736 41.2701 7.74443 42.1397 8.42543Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.5592 8.42543C56.4289 9.10644 56.5818 10.3635 55.9008 11.2332L55.2831 12.022C54.4153 13.1301 54.4153 14.6872 55.2831 15.7954L56.5185 17.373C56.5185 17.373 56.5185 17.373 56.5185 17.373C58.5205 19.9296 58.5205 23.5221 56.5185 26.0787L55.9008 26.8675C55.2198 27.7372 53.9627 27.8901 53.093 27.2091C52.2234 26.5281 52.0705 25.271 52.7515 24.4014L53.3692 23.6125C54.2369 22.5044 54.2369 20.9473 53.3692 19.8392L52.1338 18.2615C52.1338 18.2615 52.1338 18.2615 52.1338 18.2615C50.1318 15.7049 50.1318 12.1124 52.1338 9.55586C52.1338 9.55585 52.1338 9.55586 52.1338 9.55586L52.7515 8.76702C53.4325 7.89736 54.6896 7.74443 55.5592 8.42543Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubCoffeeIcon;
